// extracted by mini-css-extract-plugin
export default {"modal":"SelecionarUsuarioTransferencia_modal__js+X9"};